// extracted by mini-css-extract-plugin
module.exports = {"quoteContent":"Quote_quoteContent__gxJhS","quoteAuthor":"Quote_quoteAuthor__SeH73"};